import React, { useState, useEffect, useCallback } from 'react';
import './Carousel.css';

const Carousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const autoPlay = true;

  const images = [
    '/images/jl-0.jpg',
    '/images/jl-1.jpg',
    '/images/jl-2.jpg',
    '/images/jl-3.jpg',
    '/images/jl-4.jpg',
    '/images/jl-5.jpg',
    '/images/jl-6.jpg',
    '/images/jl-7.jpg',
    '/images/jl-8.jpg',
    '/images/jl-9.jpg',
    '/images/jl-10.jpg',
    '/images/jl-11.jpg',
    '/images/jl-12.jpg'
  ];

  const nextSlide = useCallback(() => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  }, [images.length]);

  const prevSlide = useCallback(() => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  }, [images.length]);

  const goToSlide = useCallback((index) => {
    setCurrentIndex(index);
  }, []);

  useEffect(() => {
    if (!autoPlay) return;
    const interval = setInterval(nextSlide, 3000);
    return () => clearInterval(interval);
  }, [autoPlay, nextSlide]);

  return (
    <section className="carousel-section section">
      <div className="container">
        <div className="carousel-wrapper">
          <div className="carousel-container">
            <div className="carousel-slide">
              <img
                src={images[currentIndex]}
                alt={`公司展示 ${currentIndex + 1}`}
                className="carousel-image"
              />
            </div>

            <button
              type="button"
              className="carousel-arrow carousel-arrow-prev"
              onClick={prevSlide}
              aria-label="上一张"
            >
              &#10094;
            </button>
            <button
              type="button"
              className="carousel-arrow carousel-arrow-next"
              onClick={nextSlide}
              aria-label="下一张"
            >
              &#10095;
            </button>
          </div>

          <div className="carousel-indicators">
            {images.map((img, index) => (
              <button
                type="button"
                key={img}
                className={`carousel-indicator ${index === currentIndex ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
                aria-label={`跳转到第 ${index + 1} 张图片`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Carousel;
